__turbopack_context__.v({
  "className": "caveat_3c9fe946-module__SR8KuW__className",
});
